var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-message"},[_c('base-icon',{attrs:{"name":_vm.icon.name,"size":_vm.icon.size,"color":_vm.icon.color}}),_vm._t("title"),_vm._t("subtitle"),_vm._t("component")],2)}
var staticRenderFns = []

export { render, staticRenderFns }